import { render, staticRenderFns } from "./PopinAddThemeElement.vue?vue&type=template&id=2803c6be&scoped=true&"
import script from "./PopinAddThemeElement.vue?vue&type=script&lang=js&"
export * from "./PopinAddThemeElement.vue?vue&type=script&lang=js&"
import style0 from "./PopinAddThemeElement.vue?vue&type=style&index=0&id=2803c6be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2803c6be",
  null
  
)

export default component.exports